import styled from '@emotion/styled';
import { Card } from '@lightspeed/flame/Card';
import { Modal, ModalHeader } from '@lightspeed/flame/Modal';

export const StyledCard = styled(Card)<{ disableHover: boolean }>`
  background: #ffffff;
  cursor: ${(props) => (props.disableHover ? 'not-allowed' : 'pointer')};
  transition: all 100ms ease-in-out;
  box-shadow: 0px 0px 4px rgba(12, 13, 13, 0.06), 0px 3px 6px rgba(12, 13, 13, 0.03),
    0px 1px 2px rgba(12, 13, 13, 0.1);
  &:hover {
    box-shadow: ${(props) => (props.disableHover ? undefined : '0px 6px 16px rgba(0, 0, 0, 0.1)')};
    transform: ${(props) => (props.disableHover ? undefined : 'translate(0, -1px)')};
  }
  &:focus {
    border: 1px solid red;
  }
`;

export const StyledModal = styled(Modal)`
  width: 775px;
  background: #ffffff;
  font-family: 'Lato';
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: normal;
`;

export const StyledModalHeader = styled(ModalHeader)`
  div:first-of-type {
    font-size: 16px;
  }
`;
